var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Contact = (function (Contact) {

        Contact.Messages = (function (Messages) {

            Messages.Submit = function (email, firstname, lastname, message, newsletter, address, phones, mobiles, fax, gender, customxml, reCaptchaCode, subject, contactFileUpload, currentCountryCode) {
                var data = {
                    email: email,
                    firstName: firstname,
                    lastName: lastname,
                    message: message,
                    newsletter: newsletter,
                    address: address,
                    phones: phones,
                    mobiles: mobiles,
                    fax: fax,
                    gender: gender,
                    customxml: customxml,
                    reCaptchaCode: reCaptchaCode,
                    subject: subject,
                    contactFileUpload: contactFileUpload,
                    currentCountryCode: currentCountryCode,
                    itemId: Vendd.Product.Controller.IsInitialized() ? Vendd.Product.Controller.getState().selectedId : LhApp.Context.Item.Id,
                    itemPathChecksum: LhApp.Context.Item.Path
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.Submit', data);
            };
            Messages.Submit.className = 'Vendd.Contact.Messages.Submit';

            Messages.SubmitSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.SubmitSuccess', response);
            };
            Messages.SubmitSuccess.className = 'Vendd.Contact.Messages.SubmitSuccess';

            Messages.SubmitFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.SubmitFailure', response);
            };
            Messages.SubmitFailure.className = 'Vendd.Contact.Messages.SubmitFailure';

            return Messages;

        })(Contact.Messages || {});

        return Contact;

    })(Vendd.Contact || {});

    return Vendd;

})(Vendd || {});